'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export interface HeadingProps {
  title: string;
  center?: boolean;
  uppercase?: boolean;
  className?: {
    title?: string;
    subtitle?: string;
    container?: string;
    vector?: string;
  };
  color?: 'white' | 'black';
  subtitle?: string;
  lighterSpan?: boolean;
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
  /** Preserve the design scale when the semantic heading level differs. */
  visualTag?: Exclude<HeadingProps['tag'], 'div'>;
}

export function Heading({
  title,
  className,
  tag = 'h2',
  visualTag = tag === 'div' ? 'h2' : tag,
  center = false,
  color = 'black',
  uppercase = false,
  lighterSpan = false,
  subtitle,
}: HeadingProps) {
  const Tag = title?.trim() ? tag : 'div';

  return (
    <div
      className={cn(
        'ea-heading__container',
        'flex flex-col items-start justify-start',
        className?.container,
        center && 'items-center justify-center text-center',
        subtitle && 'gap-4 sm:gap-5 lg:gap-6',
      )}
    >
      {!!subtitle && (
        <p
          className={cn(
            'text-xs font-medium uppercase leading-[130%] tracking-[15%] text-[#00A500] sm:text-sm sm:leading-[130%]',
            'ea-heading__subtitle',
            'font-heading',
            className?.subtitle,
          )}
        >
          {subtitle}
        </p>
      )}
      <Tag
        data-ea-visual-tag={tag === 'div' ? visualTag : undefined}
        dangerouslySetInnerHTML={{ __html: title }}
        className={cn(
          'relative z-[5] text-left font-semibold tracking-tight text-foreground',
          color === 'white' && 'text-white',
          center && 'text-center',
          uppercase && 'uppercase',
          visualTag,
          lighterSpan && 'ea-heading__title--lighter-span',
          className?.title,
          'ea-heading__title',
        )}
      />
    </div>
  );
}
